var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleWall),attrs:{"id":"app"}},[_c('div',{style:(_vm.styleContainer),attrs:{"id":"container_images"}},_vm._l((_vm.getNumImages),function(id){return _c('image-frame',{key:id,attrs:{"id":id - 1}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }